export const STEPS = {
  IDP_INFORMATION: 'idp_information',
  CONNECTION: 'connection',
  APPLY_TEST_SETTINGS: 'apply_test_settings'
}

export const INITIAL_SAML_TEST_SETTINGS = {
  isModalOpen: false,
  isLoading: false,
  errors: null,
  settings: {
    entity_id: '',
    sso_url: '',
    certificate: ''
  },
  step: STEPS.IDP_INFORMATION
}
